import React from "react";
import { connect } from "react-redux";
import Image from "react-bootstrap/Image";
import Spinner from "react-bootstrap/Spinner";
import "./SinglePdfPageContainer.css";
import PdfTextBox from "../PdfTextBox/PdfTextBox";
import PdfImageBox from "../PdfImageBox/PdfImageBox";
import {
  getPageDataApi,
  getPageTagApi,
  pageTagApi,
  deleteTagApi
} from "../../api/pages";
import { toast } from "react-toastify";
import { ACSTYPE_PARAGRAPH, ACSTYPE_SEC_TITLE } from "../../model/ACSTypes";
import {
  appendTocArticleRequestAction,
  orderedSendToTocArticleRequestAction
} from "../../redux/actions/tocEditPanel";
import { setPdfImageBoxesAction } from "../../redux/actions/singlePdfPageContainer";
import {
  sendTextRequestAction,
  sendImageRequestAction,
  sendMultiTextRequestAction,
  snapShotEditArticleContentAction,
  sendOrderedTextRequestAction
} from "../../redux/actions/editArticlePanel";
import ReactResizeDetector from "react-resize-detector";
import { combineTextLineIDs } from "../../model/privateACDType";
import {
  ACDTYPE_IMAGE_ARR,
  ACDTYPE_IMAGE,
  ACDTYPE_IMAGE_ONLY
} from "../../model/ACDTypes";

class SinglePdfPageContainer extends React.Component {
  document = document;

  constructor(props) {
    super(props);

    this.onComponentMouseTouchDown = this.onComponentMouseTouchDown.bind(this);
    this.onDocMouseTouchMove = this.onDocMouseTouchMove.bind(this);
    this.onDocMouseTouchEnd = this.onDocMouseTouchEnd.bind(this);
    this.handleClicked = this.handleClicked.bind(this);
    this.handleImageClicked = this.handleImageClicked.bind(this);
    this.renderImageBoxes = this.renderImageBoxes.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleMutltiTags = this.handleMutltiTags.bind(this);
    this.sendMultiTexts = this.sendMultiTexts.bind(this);
    this.handleRightClicked = this.handleRightClicked.bind(this);
    this.processDisplayingTextBoxes = this.processDisplayingTextBoxes.bind(
      this
    );
    this.onResize = this.onResize.bind(this);
    this.imageContainer = React.createRef();

    this.state = {
      width: -1,
      height: -1,
      textBoxes: {},
      selectStartPoint: null,
      selectMovingPoint: null,
      imageContainerLeft: 0,
      imageContainerTop: 0,
      loadedImageUri: null,
      realWidth: 0,
      isRightButton: false
    };
  }

  onResize(width) {
    if (this.state.realWidth !== width) {
      this.setState({ realWidth: width });
    }
  }

  componentDidMount() {
    const { isLeft, setPdfImageBoxesAction } = this.props;

    setPdfImageBoxesAction({ isLeft, imageBoxes: [] });

    this.loadPageData();

    this.document.addEventListener("mousemove", this.onDocMouseTouchMove);
    this.document.addEventListener("touchmove", this.onDocMouseTouchMove);

    this.document.addEventListener("mouseup", this.onDocMouseTouchEnd);
    this.document.addEventListener("touchend", this.onDocMouseTouchEnd);
    this.document.addEventListener("touchcancel", this.onDocMouseTouchEnd);

    this.mounted = true;
  }

  componentWillUnmount() {
    this.document.removeEventListener("mousemove", this.onDocMouseTouchMove);
    this.document.removeEventListener("touchmove", this.onDocMouseTouchMove);

    this.document.removeEventListener("mouseup", this.onDocMouseTouchEnd);
    this.document.removeEventListener("touchend", this.onDocMouseTouchEnd);
    this.document.removeEventListener("touchcancel", this.onDocMouseTouchEnd);

    this.mounted = false;
  }

  startSelecting(pos) {
    let containerRect = this.imageContainer.getBoundingClientRect();

    this.setState({
      selectStartPoint: pos,
      selectMovingPoint: pos,
      imageContainerLeft: containerRect.left + window.scrollX,
      imageContainerTop: containerRect.top + window.scrollY
    });
  }

  onComponentMouseTouchDown(e) {
    this.touchDownPos = getClientPos(e);
    this.setState({ isRightButton: e.button === 2 });
  }

  onDocMouseTouchMove(e) {
    const { selectStartPoint } = this.state;
    if (selectStartPoint != null) {
      e.preventDefault();
      this.setState({ selectMovingPoint: getClientPos(e) });
      return;
    }

    if (this.touchDownPos != null) {
      const startPos = this.touchDownPos;
      const curPos = getClientPos(e);

      if (
        Math.pow(startPos.x - curPos.x, 2) +
          Math.pow(startPos.y - curPos.y, 2) >
        5
      ) {
        e.preventDefault();
        this.startSelecting(startPos);
        this.touchDownPos = null;
      }
    }
  }

  onDocMouseTouchEnd(e) {
    this.touchDownPos = null;

    const { taggingMode } = this.props;
    const {
      textBoxes,
      width,
      height,
      selectStartPoint,
      selectMovingPoint,
      imageContainerLeft,
      imageContainerTop
    } = this.state;

    const bound = getBound(
      selectStartPoint,
      selectMovingPoint,
      imageContainerLeft,
      imageContainerTop
    );

    const container = this.imageContainer;
    const containerWidth = container == null ? 0 : container.clientWidth;
    const containerHeight = container == null ? 0 : container.clientHeight;

    const selectedTextBoxIDs = Object.keys(textBoxes).filter(aTextBoxID =>
      doesBoundContainPdfTextBox(
        containerWidth,
        containerHeight,
        bound,
        textBoxes[aTextBoxID],
        width,
        height
      )
    );

    if (selectedTextBoxIDs.length <= 0) {
      setTimeout(() => {
        if (!this.mounted) {
          return;
        }

        this.setState({
          selectStartPoint: null,
          selectMovingPoint: null
        });
      }, 275);

      return;
    }

    const { issue } = this.props;
    const isRightButton = e.button === 2;

    if (
      issue != null &&
      selectStartPoint != null &&
      selectMovingPoint != null
    ) {
      if (taggingMode) {
        if (!isRightButton) {
          this.handleMutltiTags(selectedTextBoxIDs);
        }
      } else {
        if (isRightButton) {
          this.handleRightButton(selectedTextBoxIDs);
        } else {
          this.handleLeftButton(selectedTextBoxIDs);
        }
      }
    }

    setTimeout(() => {
      if (!this.mounted) {
        return;
      }

      this.setState({
        selectStartPoint: null,
        selectMovingPoint: null
      });
    }, 275);
  }

  handleRightButton(selectedTextBoxIDs) {
    const { issue, page, inToc, lockingID } = this.props;
    const { textBoxes } = this.state;

    if (!inToc && lockingID == null) {
      toast.error("ordered texts can only be sent to locked item");
      return;
    }

    const allIndexes = selectedTextBoxIDs.map(
      aSelectedBoxID => textBoxes[aSelectedBoxID].containedWordIndexes
    );

    const flattenAllIndexes = [].concat.apply([], allIndexes);

    const data = {
      pageID: issue.pages[page].id,
      textLineIndexes: flattenAllIndexes
    };

    let textLineIDs = {};
    textLineIDs[issue.pages[page].id] = data;

    const issueID = issue.id;

    if (inToc) {
      this.props.orderedSendToTocArticleRequestAction(
        page,
        textLineIDs,
        issueID,
        toast
      );
    } else {
      this.props.sendOrderedTextRequestAction(
        page,
        textLineIDs,
        issueID,
        toast
      );
    }
  }

  handleRightClicked(aTextBox) {
    const { issue, page, inToc, taggingMode, lockingID } = this.props;

    if (issue == null) {
      return;
    }

    if (taggingMode) {
      toast.error("ordered texts can not be used in tagging mode");
      return;
    }

    if (!inToc && lockingID == null) {
      toast.error("ordered texts can only be sent to locked item");
      return;
    }

    const data = {
      pageID: issue.pages[page].id,
      textLineIndexes: aTextBox.containedWordIndexes
    };

    let textLineIDs = {};
    textLineIDs[issue.pages[page].id] = data;

    const issueID = issue.id;

    if (inToc) {
      this.props.orderedSendToTocArticleRequestAction(
        page,
        textLineIDs,
        issueID,
        toast
      );
    } else {
      this.props.sendOrderedTextRequestAction(
        page,
        textLineIDs,
        issueID,
        toast
      );
    }
  }

  handleLeftButton(selectedTextBoxIDs) {
    const { issue, page, inToc, lockingID } = this.props;
    const { textBoxes } = this.state;

    if (inToc || lockingID != null) {
      const allIndexes = selectedTextBoxIDs.map(
        aSelectedBoxID => textBoxes[aSelectedBoxID].containedWordIndexes
      );

      const flattenAllIndexes = [].concat.apply([], allIndexes);

      const data = {
        pageID: issue.pages[page].id,
        textLineIndexes: flattenAllIndexes
      };

      let textLineIDs = {};
      textLineIDs[issue.pages[page].id] = data;

      const issueID = issue.id;

      if (inToc) {
        this.props.appendTocArticleRequestAction(page, textLineIDs, issueID);
      } else {
        this.props.sendTextRequestAction(
          page,
          textLineIDs,
          ACSTYPE_PARAGRAPH,
          issueID,
          toast
        );
      }
    } else {
      this.sendMultiTexts(selectedTextBoxIDs);
    }
  }

  sendMultiTexts(selectedTextBoxIDs) {
    try {
      const { page, issue } = this.props;
      const { textBoxes } = this.state;

      const issueID = issue.id;

      const selectedTextBoxes = selectedTextBoxIDs.map(
        aSelectedBoxID => textBoxes[aSelectedBoxID]
      );

      const sortedSelectdTextBoxes = selectedTextBoxes.sort((a, b) => {
        return a.containedWordIndexes[0] - b.containedWordIndexes[0];
      });

      this.props.snapShotEditArticleContentAction();

      let textLineIndexes = [];
      for (let i = 0; i < sortedSelectdTextBoxes.length; i++) {
        const curTextBox = sortedSelectdTextBoxes[i];

        if (curTextBox.tagID != null) {
          if (textLineIndexes.length > 0) {
            const flattenTextLineIndexes = [].concat.apply([], textLineIndexes);

            const data = {
              pageID: issue.pages[page].id,
              textLineIndexes: flattenTextLineIndexes
            };

            let textLineIDs = {};
            textLineIDs[issue.pages[page].id] = data;

            this.props.sendMultiTextRequestAction(
              page,
              textLineIDs,
              ACSTYPE_PARAGRAPH,
              issueID,
              toast
            );
            textLineIndexes = [];
          }

          const data = {
            pageID: issue.pages[page].id,
            textLineIndexes: curTextBox.containedWordIndexes
          };

          let textLineIDs = {};
          textLineIDs[issue.pages[page].id] = data;
          this.props.sendMultiTextRequestAction(
            page,
            textLineIDs,
            ACSTYPE_SEC_TITLE,
            issueID,
            toast
          );
        } else {
          textLineIndexes.push(curTextBox.containedWordIndexes);
        }
      }

      if (textLineIndexes.length > 0) {
        const flattenTextLineIndexes = [].concat.apply([], textLineIndexes);

        const data = {
          pageID: issue.pages[page].id,
          textLineIndexes: flattenTextLineIndexes
        };

        let textLineIDs = {};
        textLineIDs[issue.pages[page].id] = data;

        this.props.sendMultiTextRequestAction(
          page,
          textLineIDs,
          ACSTYPE_PARAGRAPH,
          issueID,
          toast
        );
        textLineIndexes = [];
      }
    } catch (e) {
      toast.error(e.toString());
    }
  }

  componentDidUpdate(prevProps) {
    const { issue, page, isLeft, setPdfImageBoxesAction } = this.props;

    if (issue !== prevProps.issue || page !== prevProps.page) {
      this.setState({
        width: -1,
        height: -1,
        textBoxes: {}
      });

      setPdfImageBoxesAction({ isLeft, imageBoxes: [] });
      this.loadPageData();
    }
  }

  async handleMutltiTags(selectedTextBoxIDs) {
    const { textBoxes } = this.state;
    const { issue, page } = this.props;
    const pageID = issue.pages[page].id;

    const selectedTextBoxes = selectedTextBoxIDs.map(
      aTextBoxID => textBoxes[aTextBoxID]
    );
    const isTagArr = selectedTextBoxes.map(
      aSelectedTextBox => aSelectedTextBox.tagID != null
    );

    for (let i = 0; i < isTagArr.length; i++) {
      if (isTagArr[i] !== false) {
        toast.error("please use click to delete tag");
        return;
      }
    }

    try {
      for (let i = 0; i < selectedTextBoxes.length; i++) {
        textBoxes[selectedTextBoxes[i].id].isActive = false;
      }
      this.setState({ textBoxes });

      const allIndexes = selectedTextBoxes.map(
        aSelectedTextBox => aSelectedTextBox.containedWordIndexes
      );
      const flattenAllIndexes = [].concat.apply([], allIndexes);

      const tagData = await pageTagApi(pageID, flattenAllIndexes);

      let newID = tagData.id;

      let minX = selectedTextBoxes[0].x;
      let maxX = selectedTextBoxes[0].x + selectedTextBoxes[0].w;

      let minY = selectedTextBoxes[0].y;
      let maxY = selectedTextBoxes[0].y + selectedTextBoxes[0].h;

      for (let j = 1; j < selectedTextBoxes.length; j++) {
        const textBox = selectedTextBoxes[j];

        let x = textBox.x;
        let y = textBox.y;
        let bigX = x + textBox.w;
        let bigY = y + textBox.h;

        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = bigX > maxX ? bigX : maxX;
        maxY = bigY > maxY ? bigY : maxY;
      }

      textBoxes[newID] = {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY,
        containedWordIndexes: flattenAllIndexes,
        isActive: true,
        id: newID,
        tagID: newID
      };

      this.setState({ textBoxes });
    } catch (e) {
      toast.error(e.toString());
      for (let i = 0; i < selectedTextBoxes.length; i++) {
        textBoxes[selectedTextBoxes[i].id].isActive = true;
      }
      this.setState({ textBoxes });
    }
  }

  async handleTagClick(aTextBox) {
    const { textBoxes } = this.state;
    const { issue, page } = this.props;
    const pageID = issue.pages[page].id;

    if (aTextBox.tagID == null) {
      try {
        textBoxes[aTextBox.id].isActive = false;
        this.setState({ textBoxes });

        const tagData = await pageTagApi(pageID, aTextBox.containedWordIndexes);

        let newID = tagData.id;

        textBoxes[newID] = {
          x: aTextBox.x,
          y: aTextBox.y,
          w: aTextBox.w,
          h: aTextBox.h,
          containedWordIndexes: aTextBox.containedWordIndexes,
          isActive: true,
          id: newID,
          tagID: newID
        };

        this.setState({ textBoxes });
      } catch (e) {
        toast.error(e.toString());
        textBoxes[aTextBox.id].isActive = true;
        this.setState({ textBoxes });
      }
    } else {
      try {
        textBoxes[aTextBox.id].isActive = false;
        this.setState({ textBoxes });

        await deleteTagApi(aTextBox.tagID);
        for (let i = 0; i < aTextBox.containedWordIndexes.length; i++) {
          let wordIdx = aTextBox.containedWordIndexes[i];
          textBoxes[wordIdx + ""].isActive = true;
        }

        delete textBoxes[aTextBox.id];
        this.setState({ textBoxes });
      } catch (e) {
        toast.error(e.toString());
        textBoxes[aTextBox.id].isActive = true;
        this.setState({ textBoxes });
      }
    }
  }

  handleClicked(aTextBox) {
    const { issue, page, inToc, taggingMode } = this.props;

    if (issue == null) {
      return;
    }

    if (taggingMode) {
      this.handleTagClick(aTextBox);
    } else {
      const data = {
        pageID: issue.pages[page].id,
        textLineIndexes: aTextBox.containedWordIndexes
      };

      let textLineIDs = {};
      textLineIDs[issue.pages[page].id] = data;

      const issueID = issue.id;

      if (inToc) {
        this.props.appendTocArticleRequestAction(page, textLineIDs, issueID);
      } else {
        const acsType =
          aTextBox.tagID == null ? ACSTYPE_PARAGRAPH : ACSTYPE_SEC_TITLE;
        this.props.sendTextRequestAction(
          page,
          textLineIDs,
          acsType,
          issueID,
          toast
        );
      }
    }
  }

  handleImageClicked(anImageBox) {
    const { selectStartPoint, selectMovingPoint } = this.state;

    if (selectStartPoint != null && selectMovingPoint != null) {
      return;
    }

    const { issue, inToc, sendImageRequestAction } = this.props;

    if (anImageBox == null || issue == null || inToc) {
      return;
    }

    let image = {
      id: anImageBox.id,
      thumbnail: {
        id: anImageBox.id
      }
    };

    const issueID = issue.id;
    sendImageRequestAction(image, issueID, toast);
  }

  processDisplayingTextBoxes(words, tagData) {
    let textBoxes = {};
    for (let i = 0; i < words.length; i++) {
      const index = words[i].index;
      textBoxes[index + ""] = words[i];
      words[i].id = index + "";
      words[i].containedWordIndexes = [index];
      words[i].isActive = true;
      words[i].tagID = null;
    }

    for (let i = 0; i < tagData.length; i++) {
      const tagID = tagData[i].id;

      const firstOffIdx = tagData[i].word_indices[0];
      const firstOffTextBox = textBoxes[firstOffIdx + ""];
      firstOffTextBox.isActive = false;

      let minX = firstOffTextBox.x;
      let maxX = firstOffTextBox.x + firstOffTextBox.w;

      let minY = firstOffTextBox.y;
      let maxY = firstOffTextBox.y + firstOffTextBox.h;

      for (let j = 1; j < tagData[i].word_indices.length; j++) {
        const offIdx = tagData[i].word_indices[j];
        const textBox = textBoxes[offIdx + ""];

        textBox.isActive = false;

        let x = textBox.x;
        let y = textBox.y;
        let bigX = x + textBox.w;
        let bigY = y + textBox.h;

        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = bigX > maxX ? bigX : maxX;
        maxY = bigY > maxY ? bigY : maxY;
      }

      textBoxes[tagID] = {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY,
        containedWordIndexes: tagData[i].word_indices,
        isActive: true,
        id: tagID,
        tagID: tagID
      };
    }

    return textBoxes;
  }

  checkTextSizeInRange(aTextBox) {
    const { sizeRange, inToc } = this.props;

    if (inToc || !("sizes" in aTextBox)) {
      return false;
    }

    for (let i = 0; i < aTextBox.sizes.length; i++) {
      if (
        aTextBox.sizes[i] >= sizeRange[0] &&
        aTextBox.sizes[i] <= sizeRange[1]
      ) {
        return true;
      }
    }
    return false;
  }

  checkAllTextSizeInRange(aTextBox) {
    const { sizeRange, inToc } = this.props;

    if (inToc || !("sizes" in aTextBox)) {
      return true;
    }

    for (let i = 0; i < aTextBox.sizes.length; i++) {
      if (
        aTextBox.sizes[i] < sizeRange[0] ||
        aTextBox.sizes[i] > sizeRange[1]
      ) {
        return false;
      }
    }
    return true;
  }

  async loadPageData() {
    const { issue, page, isLeft, setPdfImageBoxesAction } = this.props;

    if (page < 0 || issue == null) {
      return;
    }

    try {
      const [pageData, tagData] = await Promise.all([
        getPageDataApi(issue.pages[page].id),
        getPageTagApi(issue.pages[page].id)
      ]).catch(e => {
        throw e;
      });

      if (this.props.issue !== issue || this.props.page !== page) {
        return;
      }

      const processedTextBoxes = this.processDisplayingTextBoxes(
        pageData.words,
        tagData
      );

      this.setState({
        width: pageData.width,
        height: pageData.height,
        textBoxes: processedTextBoxes
      });

      setPdfImageBoxesAction({ isLeft, imageBoxes: pageData.placeable_images });
    } catch (e) {
      toast.error(e.toString());
      this.setState({
        width: -1,
        height: -1,
        textBoxes: {}
      });

      setPdfImageBoxesAction({ isLeft, imageBoxes: [] });
    }
  }

  renderImageBoxes() {
    const {
      issue,
      page,
      inToc,
      imageBoxes,
      previewingImageIndexes,
      invisibleImageIndexes,
      highlightImageIndexes
    } = this.props;
    const { realWidth } = this.state;
    const pageData = issue.pages[page];

    if (pageData == null) {
      return null;
    }

    const images = imageBoxes;

    if (inToc || images == null || images.length <= 0) {
      return null;
    }

    const { selectStartPoint, selectMovingPoint, width, height } = this.state;

    return (
      <React.Fragment>
        {images.map((anImage, idx) => (
          <PdfImageBox
            isSelecting={selectStartPoint != null && selectMovingPoint != null}
            handleClicked={this.handleImageClicked}
            image={anImage}
            key={idx}
            index={idx}
            width={width}
            height={height}
            realWidth={realWidth}
            displayMode={this.props.displayMode}
            previewing={previewingImageIndexes.includes(anImage.id)}
            invisible={invisibleImageIndexes.includes(anImage.id)}
            highlight={highlightImageIndexes.includes(anImage.id)}
          />
        ))}
      </React.Fragment>
    );
  }

  render() {
    const {
      issue,
      page,
      isLeft,
      inToc,
      previewingLineIndexes,
      invisibleLineIndexes,
      highlightLineIndexes,
      displayMode
    } = this.props;
    const {
      textBoxes,
      width,
      height,
      selectStartPoint,
      selectMovingPoint,
      imageContainerLeft,
      imageContainerTop,
      loadedImageUri,
      isRightButton
    } = this.state;

    if (issue == null) {
      return (
        <div className="single_pdf_spinner_container">
          <Spinner animation="grow" />
        </div>
      );
    }

    const pageID =
      page >= 0 && page < issue.pages.length ? issue.pages[page].id : null;

    const pageImageUri =
      pageID != null
        ? `${process.env.REACT_APP_API_ROOT}pages/${pageID}/page_image`
        : "";

    const bound = getBound(
      selectStartPoint,
      selectMovingPoint,
      imageContainerLeft,
      imageContainerTop
    );
    const container = this.imageContainer;
    const containerWidth = container == null ? 0 : container.clientWidth;
    const containerHeight = container == null ? 0 : container.clientHeight;

    return (
      <div className="single_pdf_container">
        <div
          className="single_pdf_page_container"
          style={{ textAlign: isLeft ? "right" : "left" }}
        >
          P{page + 1}
        </div>
        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize}>
          <div
            className="single_pdf_img_area"
            ref={el => (this.imageContainer = el)}
            onTouchStart={this.onComponentMouseTouchDown}
            onMouseDown={this.onComponentMouseTouchDown}
            onContextMenu={e => e.preventDefault()}
          >
            <Image
              style={loadedImageUri === pageImageUri ? {} : { display: "none" }}
              className="pdf_page_image border"
              src={pageImageUri}
              onLoad={() => this.setState({ loadedImageUri: pageImageUri })}
            />
            {this.renderImageBoxes()}

            {Object.keys(textBoxes)
              .filter(aTextBoxID => textBoxes[aTextBoxID].isActive)
              .map(aTextBoxID => (
                <PdfTextBox
                  isSelecting={
                    selectStartPoint != null && selectMovingPoint != null
                  }
                  selected={doesBoundContainPdfTextBox(
                    containerWidth,
                    containerHeight,
                    bound,
                    textBoxes[aTextBoxID],
                    width,
                    height
                  )}
                  handleClicked={this.handleClicked}
                  handleRightClicked={this.handleRightClicked}
                  textBox={textBoxes[aTextBoxID]}
                  key={aTextBoxID}
                  width={width}
                  height={height}
                  inToc={inToc}
                  previewing={textBoxes[aTextBoxID].containedWordIndexes.every(
                    e => previewingLineIndexes.includes(e)
                  )}
                  displayMode={displayMode}
                  invisible={textBoxes[aTextBoxID].containedWordIndexes.every(
                    e => invisibleLineIndexes.includes(e)
                  )}
                  highlight={textBoxes[aTextBoxID].containedWordIndexes.every(
                    e => highlightLineIndexes.includes(e)
                  )}
                  warning={this.checkTextSizeInRange(textBoxes[aTextBoxID])}
                />
              ))}

            {selectStartPoint && selectMovingPoint && (
              <div
                className={
                  isRightButton ? "selecting_box_right" : "selecting_box"
                }
                style={bound}
              />
            )}
          </div>
        </ReactResizeDetector>
      </div>
    );
  }
}

function doesBoundContainPdfTextBox(
  imageContainerWidth,
  imageContainerHeight,
  bound,
  aTextBox,
  fullImageWidth,
  fullImageHeight
) {
  if (!aTextBox.isActive) {
    return false;
  }

  const { x, y, w, h } = aTextBox;

  const boxLeftPercent = (x * 100) / fullImageWidth;
  const boxHorizontalCenterPercent =
    boxLeftPercent + (w * 100) / fullImageWidth / 2;
  const boxTopPercent = (y * 100) / fullImageHeight;
  const boxVerticalCenterPercent =
    boxTopPercent + (h * 100) / fullImageHeight / 2;

  const selectLeftPercent = (bound.left * 100) / imageContainerWidth;
  const selectRightPercent =
    selectLeftPercent + (bound.width * 100) / imageContainerWidth;
  const selectTopPercent = (bound.top * 100) / imageContainerHeight;
  const selectBottomPercent =
    selectTopPercent + (bound.height * 100) / imageContainerHeight;

  return (
    selectLeftPercent <= boxHorizontalCenterPercent &&
    selectRightPercent >= boxHorizontalCenterPercent &&
    selectTopPercent <= boxVerticalCenterPercent &&
    selectBottomPercent >= boxVerticalCenterPercent
  );
}

function getBound(point1, point2, imageContainerLeft, imageContainerTop) {
  if (
    point1 == null ||
    point2 == null ||
    imageContainerLeft == null ||
    imageContainerTop == null
  ) {
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  }

  let x;
  let y;
  let width;
  let height;

  if (point1.x < point2.x) {
    x = point1.x;
    width = point2.x - point1.x;
  } else {
    x = point2.x;
    width = point1.x - point2.x;
  }

  if (point1.y < point2.y) {
    y = point1.y;
    height = point2.y - point1.y;
  } else {
    y = point2.y;
    height = point1.y - point2.y;
  }

  return {
    left: x - imageContainerLeft,
    top: y - imageContainerTop,
    width,
    height
  };
}

function getClientPos(e) {
  let pageX;
  let pageY;

  if (e.touches) {
    [{ pageX, pageY }] = e.touches;
  } else {
    ({ pageX, pageY } = e);
  }

  return {
    x: pageX,
    y: pageY
  };
}

const mapDispatch = {
  appendTocArticleRequestAction,
  sendTextRequestAction,
  sendImageRequestAction,
  sendMultiTextRequestAction,
  snapShotEditArticleContentAction,
  sendOrderedTextRequestAction,
  orderedSendToTocArticleRequestAction,
  setPdfImageBoxesAction
};

const mapState = (state, ownProps) => {
  const { editArticlePanel, singlePdfPageContainer } = state;
  const {
    lockingID,
    previewingTextLineIDs,
    previewingImageIDs,
    previewHidingItemIDs,
    mode,
    contentEditHistory,
    metaEditHistory
  } = editArticlePanel;

  let itemsDict = {};
  let metaDict = {};

  if (contentEditHistory[contentEditHistory.length - 1] != null) {
    itemsDict = contentEditHistory[contentEditHistory.length - 1].itemsDict;
  }

  if (metaEditHistory[metaEditHistory.length - 1] != null) {
    metaDict = metaEditHistory[metaEditHistory.length - 1];
  }

  const { issue, page, inToc } = ownProps;

  let previewingLineIndexes = [];
  let previewingImageIndexes = [];
  let invisibleLineIndexes = [];
  let invisibleImageIndexes = [];
  let highlightLineIndexes = [];
  let highlightImageIndexes = [];

  if (!inToc && mode === "preview") {
    const pageID =
      page >= 0 && page < issue.pages.length ? issue.pages[page].id : null;

    if (pageID != null) {
      if (
        previewingTextLineIDs != null &&
        previewingTextLineIDs[pageID] != null
      ) {
        previewingLineIndexes = previewingTextLineIDs[pageID].textLineIndexes;
      }

      const itemIDs = Object.keys(previewHidingItemIDs);
      const invisibleItemIDs = itemIDs.filter(
        anItemID => previewHidingItemIDs[anItemID] === "invisible"
      );
      const highlightItemIDs = itemIDs.filter(
        anItemID => previewHidingItemIDs[anItemID] === "highlight"
      );

      const invisibleTextLineIDs = getCombinedTextLineIDs(
        invisibleItemIDs,
        itemsDict,
        metaDict
      );
      const highlightTextLineIDs = getCombinedTextLineIDs(
        highlightItemIDs,
        itemsDict,
        metaDict
      );

      if (
        invisibleTextLineIDs != null &&
        invisibleTextLineIDs[pageID] != null
      ) {
        invisibleLineIndexes = invisibleTextLineIDs[pageID].textLineIndexes;
      }

      if (
        highlightTextLineIDs != null &&
        highlightTextLineIDs[pageID] != null
      ) {
        highlightLineIndexes = highlightTextLineIDs[pageID].textLineIndexes;
      }

      if (previewingImageIDs != null) {
        previewingImageIndexes = previewingImageIDs;
      }

      const invisibleImageIDs = getCombinedImageIDs(
        invisibleItemIDs,
        itemsDict,
        metaDict
      );
      const highlightImageIDs = getCombinedImageIDs(
        highlightItemIDs,
        itemsDict,
        metaDict
      );

      if (invisibleImageIDs != null) {
        invisibleImageIndexes = invisibleImageIDs;
      }

      if (highlightImageIDs != null) {
        highlightImageIndexes = highlightImageIDs;
      }
    }
  }

  return {
    lockingID,
    previewingLineIndexes,
    previewingImageIndexes,
    invisibleLineIndexes,
    invisibleImageIndexes,
    highlightLineIndexes,
    highlightImageIndexes,
    imageBoxes: ownProps.isLeft
      ? singlePdfPageContainer.leftImageBoxes
      : singlePdfPageContainer.rightImageBoxes
  };
};

const reducer = (accumulator, currentValue) =>
  combineTextLineIDs(accumulator, currentValue.textLineIDs);

const textLineIDsreducer = (accumulator, currentValue) =>
  combineTextLineIDs(accumulator, currentValue);

function getCombinedTextLineIDs(inputItemIDs, itemsDict, metaDict) {
  const textLineIDsArray = inputItemIDs.map(anID => {
    let item = itemsDict[anID];

    if (item == null) {
      item = metaDict[anID];

      if (item == null) {
        return null;
      }
    }

    if (item.dataType === ACDTYPE_IMAGE_ARR) {
      const allTextLineIDs = item.imageItemArr.reduce(
        reducer,
        item.textLineIDs
      );
      return allTextLineIDs;
    } else {
      return item.textLineIDs;
    }
  });

  const outputTextLineIDs = textLineIDsArray.reduce(textLineIDsreducer, null);

  return outputTextLineIDs;
}

function getCombinedImageIDs(inputItemIDs, itemsDict, metaDict) {
  const imageIDsArray = inputItemIDs.map(anID => {
    let item = itemsDict[anID];

    if (item == null) {
      item = metaDict[anID];

      if (item == null) {
        return null;
      }
    }

    if (item.dataType === ACDTYPE_IMAGE_ARR) {
      const allImageIDs = item.imageItemArr.map(item => item.image.id);
      return allImageIDs;
    } else if (item.image != null) {
      return [item.image.id];
    } else {
      return null;
    }
  });

  const outputImageIDs = imageIDsArray.flat(1);

  return outputImageIDs;
}

export default connect(
  mapState,
  mapDispatch
)(SinglePdfPageContainer);
